/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetChallengePrizeBody
 */
export interface ResetChallengePrizeBody {
    /**
     * 
     * @type {boolean}
     * @memberof ResetChallengePrizeBody
     */
    deleteDrawLogs?: boolean;
}

/**
 * Check if a given object implements the ResetChallengePrizeBody interface.
 */
export function instanceOfResetChallengePrizeBody(value: object): value is ResetChallengePrizeBody {
    return true;
}

export function ResetChallengePrizeBodyFromJSON(json: any): ResetChallengePrizeBody {
    return ResetChallengePrizeBodyFromJSONTyped(json, false);
}

export function ResetChallengePrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetChallengePrizeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteDrawLogs': json['deleteDrawLogs'] == null ? undefined : json['deleteDrawLogs'],
    };
}

export function ResetChallengePrizeBodyToJSON(json: any): ResetChallengePrizeBody {
    return ResetChallengePrizeBodyToJSONTyped(json, false);
}

export function ResetChallengePrizeBodyToJSONTyped(value?: ResetChallengePrizeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deleteDrawLogs': value['deleteDrawLogs'],
    };
}

